<template>
  <div class="info-list">
    <!-- 分类筛选 -->
    <div class="filter-section">
      <select v-model="activeCategory" class="category-select">
        <option value="">全部文章</option>
        <option v-for="cat in categories" :value="cat" :key="cat">{{ cat }}</option>
      </select>
    </div>

    <!-- 文章列表 -->
    <div class="info-container">
      <div v-for="item in filteredList" :key="item.id" class="info-card" @click="handleCardClick(item)">
        <div class="card-header">
          <span class="category-tag" :class="getCategoryClass(item.category)">{{ item.category }}</span>
          <h3 class="info-title">{{ item.title }}</h3>
        </div>
        <div class="card-body">
          <p class="info-summary">{{ truncateText(item.content, 100) }}</p>
          <div class="article-meta">
            <time class="publish-time">{{ formatDate(item.publishTime) }}</time>
            <span v-if="item.isPaid" class="price-tag">¥{{ item.price }}</span>
          </div>
        </div>
        <div class="card-footer" v-if="item.isPaid && !isLoggedIn">
          <button class="read-more-btn" @click.stop="handlePaidContent">
            付费阅读全文
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  data() {
    return {
      activeCategory: '',
      categories: ['就医相关', '药品相关', '中医相关', '饮食相关', '老年人健康', '职业病知识科普'],
      isLoggedIn: false,
      infoList: [
        {
          id: 1001,
          title: '70个医学健康小知识，每个人都应该看看',
          category: '就医相关',
          content: '70个医学健康小知识，每个都超级实用，关系到我们每个人的健康，赶快来了解一下吧！\n\n1.就医篇\n\n1.首次就诊不用挂专家号\n首诊主要是询问病史、开具相关检验检查，挂普通号就可以。\n\n2.不管服用任何药物，都要忌吸烟\n烟中含有的盐碱会加快肝脏降解药物的速度，导致血液中药物浓度下降。\n\n3.乳腺增生不用治\n一个体检下来，10个女性8个有"乳腺增生"问题，绝大多数是良性的，注意定期复查即可。\n\n4.看到治疗宫颈糜烂的医院赶紧跑\n"宫颈糜烂"这个名称已经被取消，如果被诊断为这个东西，说明医院或者医生不靠谱。\n\n5.得糖尿病不是因为吃糖多\nⅠ型糖尿病的主因是遗传，Ⅱ型糖尿病的主要原因是肥胖。\n\n6.抓伤咬伤后注射狂犬疫苗非常重要\n狂犬病的致死率几乎是100%，有效的预防手段是注射疫苗，哪怕没有出血。\n\n7.别重复用药\n以感冒药为例，多数感冒药都含有解热镇痛的化学成分乙酰氨基酚，如同时服用多种感冒药，或是中西药物混合使用，总剂量会在不知不觉中超量，造成肝脏受损。\n\n8.体检非常重要\n越早诊断和开始治疗，效果越好。\n\n9.打鼾其实是病\n严重的还会引起呼吸暂停，甚至有些人还会在睡梦中死亡。\n\n10.感冒不一定要吃药，但要小心并发症\n感冒不一定要吃药，但若超过7天，病情还不好转，应及时寻求医生的帮助。\n\n11.腹泻不用禁食\n传统的腹泻治疗方法，主张让孩子禁食一段时间。其实这样不利于身体的营养补充。\n\n12.不要往伤口上抹任何粉状的东西\n不管是割伤还是烫伤，受伤后在伤口表面涂抹的粉状物会造成严重的疤痕增生。\n\n13.抗生素一定要遵医嘱足量、足时使用\n细菌耐药性的产生，就是因为细菌不能被抗生素完全杀死，残留下部分耐药性强的成为优势菌群。\n\n14.流鼻血仰头没用\n仰头会导致血液被吞下，而产生不适感或呕吐。出血量大时，还容易吸入气管及肺内。\n\n15.不要相信任何能快速治愈严重皮肤病的方法\n对于银屑病、白癜风等疾病，病因主要是自体免疫的异常。所谓偏方几乎都使用了重金属毒剂。这类方法确实可缓解症状，但肾脏和肝脏也会受影响。\n\n16.脚气是一个全身性疾病\n只要脚上有可见的感染灶，一般全身都会有真菌分布，要根治需配合口服抗真菌药。',
          publishTime: '2024-03-20',
          isPaid: true,
          price: 9.9
        },
        {
          id: 1002,
          title: '关爱生命健康，守护药品安全——安全用药常识',
          category: '药品相关',
          content: '药品是一把"双刃剑"，既能救人，又能害人。生活中我们经常和药品打交道，知道药品如果能够"对症下药"就能够救人，反之就有可能害人，所以说药品本身就是一把"双刃剑"，在生活中如何能够根据病情，真正做到"对症下药"，掌握一些用药的常识对我们来说是非常有必要的。\n\n一、哪些药物不能用热水服用\n1.助消化类 ，如多酶片、酵母片等，此类药中的酶是活性蛋白质，遇热后即凝固变性而失去应有的催化剂作用。\n2.维生素C ，它是水溶性制剂，不稳定，遇热后易还原而失去药效。\n3.止咳糖浆类，止咳药溶解在糖浆里，覆盖在发炎的咽部粘膜表面，形成保护性的薄膜，能减轻粘膜炎症反应，阻断刺激而缓解咳嗽。若用热水冲服会稀释糖浆，降低粘膜稠度，不能生成保护性薄膜。\n\n二、家庭药箱配置的误区\n误区一：选药不当，药店一般出售保健品、非处方药品、处方药品三大类。非处方药是指那些无需持医生处方，市民可直接从药店购买的药物，其外包装盒上有"OTC"标志；如果药品外包装盒上无OTC标志，且标明是"药准字号"，则这类药属于处方药；保健品包装盒上则是"食字号"标志。"家庭药箱"应尽量选择安全性高的OTC药品。某些导购员推荐一些不合适的药品，市民购买时一定要注意识别。\n\n误区二：购买过量。有些市民为图方便，在药店一次性购买许多药。但太多的药品用不完容易过期，服药过量或不当可能会造成自身器官损害或浪费。\n\n误区三：没有及时清理。大部分家庭没有定期清理药箱的习惯，有的家庭还怕浪费，认为服用外观无异样的过期药对健康没损害。\n\n注意：许多药由于稳定性较差，易受光线、温度、湿度等影响，吃剩的药品如未在合适条件下存放，容易出现爆裂、发霉、斑点、自融、水化等现象，这种变质药不能吃。还有些药从表面上看不出异样，但也不能服用，因为药品一旦过了有效期，药效会降低，毒性则会增高。\n\n三、酒后服药\n酒的主要成分是乙醇，能与许多药物发生相互作用，应用药物时饮酒，将会引起药效降低或增加毒性反应，严重时甚至可以危及生命，应当引起大家注意。',
          publishTime: '2024-03-18',
          isPaid: true,
          price: 12.9
        },
        {
          id: 1003,
          title: '中医基础知识大全',
          category: '中医相关',
          content: '中医基础知识大全\n\n1．有机整体的中心是：五脏。\n2．有机整体的主宰是：心。\n3．阳中之阳的时间是：上午。\n4．阴中之阴的时间是：前半夜。\n5．阳中之阴的时间是：下午。\n6．阳中之阳的时间是：上午。\n7．说明阴阳互根的是：阴在内，阳之守也。\n8．说明对立制约的是：动极者镇之以静。\n9．说明阴阳互根的是：阴中求阳。\n10．说明阴阳转化的是：热极生寒。\n11．称"阳中之阳"的脏是：心。\n12．称"阴中之阳"的脏是：肝。\n13．称"阴中之阴"的脏是：肾。\n14．称"阳中之阴"的脏是：肺。\n15．阴偏胜所致证候是：实寒证。\n16．阴偏衰所致证候是：虚热证。\n17．阳偏胜所致证候是：实热证。\n18．阳偏衰所致证候是：虚寒证。\n19．根据阴阳互根确定的治法是：阳中求阴。\n20．适用于阳偏衰的治法是：阴病治阳。\n21．根据阴阳对立制约确定的治法是：热者寒之。\n22．适用于阳偏胜的治法是：热者寒之。\n23．"木"的特性是：曲直。\n24．"水"的特性是：润下。\n25．属于"金"的音是：商音。\n26．属于"水"的音是：羽音。\n27．木的"所不胜"之行是：金。\n28．水的"所胜"之行是：火。\n29．金的子行为：水。\n30．火的母行为：木。\n31．木的"所不胜"之"子"是：水。\n32．木的"母"之"所胜"是：火。\n33．肝病传脾的是：相乘。\n34．肝病传心的是：母病及子。\n35．肺病及肾是：母病及子。\n36．木火刑金是：相侮。\n37．"见肝之病，知肝传脾"属于：相乘。\n38．"水气凌心"属于：相乘。\n39．喜胜：悲。\n40．恐胜：喜。\n41．属于"火"的是：喜。\n42．属于"金"的是：悲。\n43．属于"水"的是：耳。\n44．属于"土"的是：口。\n45．属于"水"的是：咸。\n46．属于"木"的是：酸。\n47．属于"水"的是：黑。\n48．属于"金"的是：白。\n49．"君主之官"指：心。\n50．"将军之官"指：肝。\n51．"生之本"指：心。\n52．"罢极之本"指：肝。\n53．"气之根"是指：肾。\n54．"气之主"是指：肺。\n55．"先天之本"是指：肾。\n56．"后天之本"是指：脾。\n57．"生气之源"指：脾。\n58．"主气之枢"指：肺。\n59．"生痰之源"指：脾。\n60．"贮痰之器"指：肺。\n61．主行血的是：心。\n62．主统血的是：脾。\n63．朝百脉的是：肺。\n64．主生血的是：脾。\n65．通调水道的是：肺。\n66．运化水液的是：脾。\n67．主行血的是：心。',
          publishTime: '2024-03-15',
          isPaid: true,
          price: 14.9
        },
        {
          id: 1004,
          title: '脾胃不好的人，少吃这3类水果',
          category: '饮食相关',
          content: '水果是公认的健康食物，不仅能满足口腹之欲，还可以增加维生素、矿物质、膳食纤维等营养物质的摄入。\n但是对于脾胃不好的人来说，吃某些水果反而会加重脾胃负担。\n脾胃不好少吃3种水果\n广州中医药大学第一附属医院脾胃病科主任医师李常青表示，对于胃不好的人来说，并非所有水果都适合食用。下面几种水果吃多了，可能让脾胃越来越差。\n1 酸度高的\n酸味水果含有单宁、原花青素等多酚类物质，以及一定量的蛋白酶，均能引起蛋白质凝固，如果胃中黏液分泌不足，可能让消化道黏膜表面受损。\n过多食用百香果、山楂等酸味水果，易引起肠胃不适，影响正常消化吸收，甚至加重胃痛、烧心等不适症状。建议选择较"温和"的苹果、香蕉、桃子、草莓等水果。\n2 寒凉属性的\n胃喜温恶寒，脾胃虚寒的人尤其要注意避免过多摄入寒凉食物。\n西瓜、柿子等寒凉属性的水果容易损伤脾胃阳气，进一步降低脾胃的运化功能，吃多了可能会出现消化不良、腹痛、腹泻等症状。\n3 反季节水果\n反季节水果往往是通过特殊的种植技术或在大棚环境中培育出来的。它们不仅在口感和营养成分上与应季水果有差异，为了保鲜和运输，可能还会使用一些化学药剂。\n胃不好的人，肠胃功能相对弱，对于这些 "特殊成分" 可能难以适应和消化，吃多了容易加重不适。\n水果不同吃法各有利弊\n《中国居民膳食指南（2022）》推荐成年人每日食用水果200~350克（一般为1~2个拳头大小），建议每天至少1~2种水果。\n对大多数人来说，直接吃新鲜水果是最佳选择。但有些人觉得直接吃麻烦，喜欢榨成汁喝或吃水果干，这些"花式"吃法对水果的营养价值有什么影响？\n榨汁喝 营养损失大\n水果榨汁之后，有两种营养素损失很大：\n维生素C，这种营养素比较"娇气"，怕热怕氧气，榨汁过程中易发生氧化。\n膳食纤维，原因在于绝大多数水果榨汁后，水果残渣都被过滤掉了，而膳食纤维主要集中在这些水果残渣中。\n水果榨汁过程中，细胞壁会被破坏，其中的果糖、葡萄糖等被释放出来，这些糖在人体内的吸收率显著提高，更容易进入人体参与代谢。即使果汁中没有添加糖，喝了之后也会导致血糖快速升高。\n水果干 保留大部分营养\n水果干保留了水果中的大部分营养，只有一些怕热的营养素被破坏，比如维生素C。美国《营养学会杂志》刊登的一项研究发现，水果干的升糖指数并不高，对消化道的刺激比水果小，且饱腹感较强。\n需要注意的是，水果干热量很高，所以要严格限量。每天吃1~2次，每次1小把即可。\n水果干不能替代新鲜水果，而且要分清"水果干"和"果脯""蜜饯"的区别。果脯和蜜饯会添加大量糖，对健康没啥好处。\n做熟吃 两类水果很适合\n水果加热后会变软易消化，虽然会流失其中不耐热的水溶性营养素，但是大部分矿物质、膳食纤维、糖类等营养成分被保留了下来。这两种水果很适合熟吃：\n蔫了的水果。可以切块放入半锅水中，中火慢炖，汤和果实一起食用，润燥又润肠道。',
          publishTime: '2024-03-22',
          isPaid: true,
          price: 8.9
        },
        {
          id: 1005,
          title: '食品药品安全知识普及',
          category: '饮食相关',
          content: '一、什么是合理用药?\n世界卫生组织对合理用药要求是，药物适合患者临床需要、药物的剂量，符合患者个体需要、疗程足够和药价。具体标准是，\n1.处方的药应为适宜的药物。\n2.在适宜的时间，以公众能支付的价格保证药物供应。\n3.正确地调剂处方。\n4.以准确的剂量，正确的用法和疗程服用药物。\n5.确保药物质量安全有效。\n二、不同的人服用同样的药，为什么有的人有不良反应，有的人没有不良反应?\n主要是因为人与人之间对药品不良反应的敏感性方面有较大的个体差异。\n三、哪些药可能影响儿童的健康?\n已有资料表明，链霉素、卡那霉素、庆大霉素有可能损害儿童的听神经引起耳聋，多黏菌素、去甲肾上腺素能引起儿童的肾脏损伤，胃复安能引起一些儿童的脑损伤，四环素、氟哌酸等药物能影响幼儿牙齿、骨骼的发育等，因此，儿童用药的选择应特别慎重。\n四、患者发现可疑药品不良反应该怎么办?\n患者发现可疑药品不良反应，立即停止服用，去医院就诊。向医药专业人员咨询，可疑症状确属药品不良反应，今后应避免再服用同样药物。根据《药品不良反应监测管理办法》规定，个人发现药品可疑不良反应，应向所在省、自治区、直辖市药品不良反应监测中心或药品监督管理局报告。\n五、药物依赖性分为哪几类?\n世界卫生组织将药物依赖性分为精神依赖性和身体依赖性。精神依赖性又称心理依赖性。凡能引起令人愉快意识状态的任何药物即可引起精神依赖性，精神依赖者为得到欣快感而不得不定期或连续使用某些药物。身体依赖性也称生理依赖性。用药者反复地应用某种药物造成一种适应状态，停药后产生戒断症状，使人非常痛苦，甚至危及生命。能引起依赖性的药物常兼有精神依赖性和身体依赖性，阿片类和催眠镇痛药在反复用药过程中，先产生精神依赖性，后产生身体依赖性。可卡因、苯丙胺类中枢兴奋药主要引起精神依赖性，但大剂量使用也会产生身体依赖性。少数药物如致幻剂只产生精神依赖性而无身体依赖性。\n如何判别伪劣食品?\n伪劣食品犹如过街老鼠，人人喊打。但人们在日常购物时却难以识别。《伪劣食品防范"七字法"》，以通俗易懂易记的方式引导消费者强化食品安全自我防范，以期使伪劣食品因缺乏市场而退出市场。防范"七字法"：即防"艳、白、反、长、散、低、小"。\n一防"艳"。对颜色过分艳丽的食品要提防，如目前上市的草莓象蜡果一样又大又红又亮、咸菜梗亮黄诱人、瓶装的蕨菜鲜绿不褪色等，要留个心眼，是不是在添加色素上有问题?\n二防"白"。凡是食品呈不正常不自然的白色，十有八九会有漂白剂、增白剂、面粉处理剂等化学品的危害。\n三防"长"。尽量少吃保质期过长的食品，3℃贮藏的包装熟肉禽类产品采用巴氏杀菌的，保质期一般为7—30天。\n四防"反"。就是防反自然生长的食物，如果食用过多可能对身体产生影响。\n五防"小"。要提防小作坊式加工企业的产品，这类企业的食品平均抽样合格率最低，触目惊心的食品安全事件往往在这些企业出现。\n六防"低"。"低"是指在价格上明显低于一般价格水平的食品，价格太低的食品大多有"猫腻"。\n七防"散"。散就是散装食品，有些集贸市场销售的散装豆制品、散装熟食、酱菜等可能来自地下加工厂。\n一、 什么是食品质量安全?\n食品质量安全是指食品质量状况对食用者健康、安全的保证程度。包括三方面内容：\n一是食品的污染导致的质量安全问题。例：生物性污染、化学性污染、物理性污染等。\n二是食品工业技术发展所带来的质量安全问题。如：食品添加剂、食品生产配剂、介质以及辐射食品、转基因食品等。\n三是滥用食品标识。例：伪造食品标识、缺少警示说明、虚假标注食品功能或成分、缺少中文食品标识(进口食品)等。',
          publishTime: '2024-03-21',
          isPaid: true,
          price: 10.9
        },
        {
          id: 1006,
          title: '普及食品安全常识',
          category: '饮食相关',
          content: '把好食品安全关吧！\n\n1、培养饮食安全习惯\n1.养成良好的饮食习惯，饭前要洗手，洗干净、煮熟了的食物才能食用。2.一日三餐要吃好，定时定量进食，切忌暴饮暴食。3.不吃生冷食物、不吃不洁瓜果、不吃腐败变质食物、不吃冷菜、不喝生水、不吃垃圾食品。4.用餐餐具洗净、消毒，不用不洁容器盛装食品，不乱扔垃圾防止蚊蝇孳生。5.剧烈运动后不要急于吃食物或喝水。\n\n2、引起食物中毒的常见因素\n1.在食物危险温度带（5℃~60℃，尤其是37℃~42℃区间）贮藏食物。2.不适当地冷却/加热/解冻食物。3.从烹调到食用的时间间隔太长，使细菌有足够的繁殖时间。4.生熟食品交叉污染。5.使用受污染的生食品或原辅料。6.已加工的食物被污染 。7.厨房设备、餐具等清洗、消毒的方法不正确。8.由病原携带者或感染者加工食品。\n\n3、食物中毒应急措施\n食物中毒的应急措施主要保包括催吐、中和解毒、洗胃和导泻等。催吐可排出残留在胃内的毒物，适用于意识清醒且没有呕吐患者，催吐时可以用手指或筷子刺激舌根部，促使胃内容物呕出。中和解毒是指在中毒后立即口服蛋清、牛奶等，中和沉淀有毒物质。洗胃是指在医院内，用洗胃机或者用人工方法排出毒物，可以清除胃内残留的有毒物质，减少毒素的吸收。对于已经进入肠道的毒物，可以使用导泻药来促进毒物的排出。但导泻药不能过度使用，以免引起身体脱水或肠道损伤。应在医生的指导下使用导泻药。此外，食物中毒后，患者可能会出现呕吐、腹泻等症状，导致水电解质失衡。患者应多喝水、淡盐水或补充电解质溶液，以维持水电解质平衡。中毒症状严重时，应及时寻求医疗帮助，拨打120急救电话或前往最近的医疗机构就诊。\n\n4、预防食物中毒的措施\n防范食物中毒，需要从方方面面进行注意。第一，食物要清洁，生熟食品要分开。第二，生鲜食物要彻底加热，避免食用未经充分烹饪的食品，如生鱼片、生鸡蛋、生奶酪等。第三，检查食品保质期，避免食用过期食品，不吃霉变食物，不吃隔夜菜。第四，选择新鲜安全的食物，避免购买来源不明的食品，避免食用不明来历的野山菌。第五，保持良好个人卫生习惯，勤洗手，特别是在处理食物之前和上厕所之后。',
          publishTime: '2024-03-23',
          isPaid: true,
          price: 9.9
        },
        {
          id: 1007,
          title: '建立科学饮食文化',
          category: '饮食相关',
          content: '以及春季防过敏这些误区要警惕，"春季万物复苏，过敏原比较多，比如柏树、杨树、梧桐、桉树，这些树种产生的花粉颗粒比较小，而且飘得比较远，所以容易造成过敏。"在3月19日国家卫生健康委召开的例行新闻发布会上，北京地坛医院主任医师蒋荣猛提醒公众，易过敏的人群，外出时要尽量避开花粉高发时段；如果有条件，应根据当地的花粉监测数据选择出行。\n\n什么样的人群容易花粉过敏？针对过敏症状有哪些预防和治疗的措施？此外，春季还有哪些健康问题应注意预防？与会专家进行了现场解读。\n\n"有过敏家族史的，如过敏性哮喘、过敏性鼻炎或湿疹人群容易发生过敏。此外，免疫功能不太成熟的儿童和青少年也容易过敏。"蒋荣猛说，压力较大导致机体免疫功能紊乱或者经常在过敏原环境中久待都容易使人发生过敏。\n\n过敏是可以预防的。蒋荣猛表示，一些过敏严重的人群可以在医生指导下在花粉高发季之前使用预防性药物。另外，要通过规律作息、良好睡眠、避免摄入辛辣刺激食物或酒精等降低过敏几率。\n\n在花粉高发时段，蒋荣猛建议，公众出行采取佩戴口罩、护目镜，穿着长袖衣等防护措施，外出后用生理盐水清洗鼻腔；关闭居室门窗，并对家里的床单、被褥、窗帘、地毯等进行定期清洁。\n\n针对春季过敏治疗的一些误区，蒋荣猛提醒，春季过敏很难做到完全根治，不要相信打一针就能把过敏完全治好的药物广告。\n\n"有人认为抗过敏药物会上瘾也是没有科学依据的。"蒋荣猛说，当前使用的抗过敏药包括抗组胺药、鼻用激素，均不会引发上瘾，但长期使用会出现嗜睡等副作用。\n\n"过敏者应在医生指导下制定一个长期的管理计划，通过环境控制、生活方式改变、恰当的药物治疗、脱敏治疗等措施，症状可逐渐好转。"蒋荣猛说，一些过敏者感觉好了就停药是不可取的，因为一旦停药可能会引起过敏症状的反复甚至加重。',
          publishTime: '2024-03-24',
          isPaid: true,
          price: 11.9
        },
        {
          id: 1008,
          title: '如何辨别每天吃的食物是否安全？',
          category: '饮食相关',
          content: '药品追溯码医保应用的五问五答，近日，国家医保局通过药品追溯码核查有关问题引发关注。药品追溯码是什么？药品追溯码被重复扫码意味着什么？药品追溯码对保障医保基金安全有哪些作用？药品追溯码怎么用？小编整理了社会普遍关心的几个问题，为大家解答。\n\n问题1：药品追溯码是什么？\n答：药品追溯码是药品的"电子身份证"，通常由一系列数字、字母和（或）符号组成，标识在药品包装盒的显著位置，是每一盒药品从生产出厂时就被赋予的唯一身份标签。若在流通过程中药品追溯码重复出现，则该药品就可能是"回流药"、假药或是被串换销售。\n\n药品追溯码主要有三个特点：一是具有唯一性。每一盒药品都有唯一的追溯码，不同盒药的追溯码各不相同；正如每个人都有唯一的身份证号码，不同人的身份证号码各不相同。二是应用于"最小包装单元"。药品的每个"最小包装单元"都有各自唯一的追溯码，确保每个"最小包装单元"药品的生产、销售路径都可查询、可追溯。三是具有大数据效应。目前，医保部门正在大力推进药品追溯码采集、应用工作。医保部门采集的追溯码数据越全面、越丰富、越完整，追溯码发挥的效用就越大。\n\n问题2：如何通过追溯码发现"回流药"、药品被"串换"销售等线索，保护医保基金安全？\n答：按照有关药品和医保管理规定，一盒药品卖给患者后，就不能再被卖给别的患者，只能卖一次，因此，一盒药品的追溯码，只应有一次被最终销售扫码的记录。若存在多次终端结算扫码记录，则该药品就可能是"回流药"或是被串换销售。\n\n一些不法分子使用医保基金购买药品后，不是自己使用，而是转手倒卖，将药品二次销售甚至多次销售，以骗取医保基金。这种经倒卖的药品被称为"回流药"。',
          publishTime: '2024-03-25',
          isPaid: true,
          price: 10.9
        },
        {
          id: 1009,
          title: '中医基础知识入门自学指南',
          category: '中医相关',
          content: '中医，作为中国传统医学的瑰宝，其理论体系博大精深，涵盖了整体观念、辩证论治、阴阳五行等多个方面。本文旨在为初学者提供一份中医基础知识入门自学指南，帮助读者快速了解中医的基本框架和核心概念。\n\n1.整体观念与辩证论治\n整体观念：中医强调人体是一个有机整体，五脏六腑、四肢百骸通过经络相互关联，并与外界环境密切相关。\n辩证论治：中医通过四诊（望、闻、问、切）收集症状，分析病因、病性、病位，确定证候，进而制定个性化的治疗方案。\n\n2.阴阳学说\n阴阳定义：阴阳是对自然界相互关联的事物或现象对立双方属性的概括，具有对立统一的内涵。\n阴阳关系：包括对立制约、互根互用、交感互藏、消长转化等。\n应用实例：如"阳病治阴"、"阴病治阳"等治疗原则。\n\n3.五行学说\n五行定义：金、木、水、火、土五种基本物质及其运动变化。\n相生相克：五行之间存在相生（如木生火）和相克（如木克土）的关系。\n应用实例：如滋水涵木、益火补土等治法。\n\n4.脏腑经络\n脏腑功能：五脏（心、肝、脾、肺、肾）和六腑（胆、胃、小肠、大肠、膀胱、三焦）各有其独特的生理功能。\n经络系统：经络是气血运行的通道，联系脏腑与体表，具有沟通内外、运行气血、调节平衡的作用。\n\n5.病因病机\n病因：包括外感六淫（风、寒、暑、湿、燥、火）和内伤七情（喜、怒、忧、思、悲、恐、惊）等。\n病机：疾病发生、发展、变化的机制，如正邪相争、气血失调等。\n\n6.治疗方法\n中药：根据药物的性味归经，采用四气五味、升降浮沉等理论进行配伍。\n针灸：通过针刺或艾灸等刺激经络穴位，达到调和气血、疏通经络、扶正祛邪的目的。\n推拿按摩：运用手法作用于人体体表特定部位，以调节机体生理、病理状况。',
          publishTime: '2024-03-26',
          isPaid: true,
          price: 15.9
        },
        {
          id: 1010,
          title: '医学小常识（一）：基础生理指标解读',
          category: '就医相关',
          content: '1. 正常心率：每分钟75次\n健康成年人安静状态下，心率平均为每分钟75次。正常范围为每分钟60-100次。成人安静时心率超过100次/分钟，为心动过速；低于60次/分钟者，为心动过缓。心率可因年龄、性别及其他因素而变化，比如体温每升高1℃，心率可加快12-20次/分钟，女性心率比男性心率稍快，运动员的心率较慢。\n\n2. 正常体温：36.3℃-37.2℃（口测法）\n临床上通常用口腔温度、直肠温度和腋窝温度来代表体温。口测法（舌下含5分钟）正常值为36.3℃-37.2℃；腋测法（腋下夹紧5分钟）为36℃-37℃；肛测法（表头涂润滑剂，插入肛门5分钟）为36.5℃-37.7℃。在一昼夜中，人体体温呈周期性波动，一般清晨2-6时最低，下午13-18时最高，但波动幅度一般不超过1℃。只要体温不超过37.3℃，就算正常。\n\n3. 血红蛋白（HbB）：成年男性（120-160克/升），成年女性（110-150克/升）\n临床上以血红蛋白值作为判断贫血的依据。正常成人血红蛋白值90-110克/升属轻度贫血；60-90克/升属中度贫血；30-60克/升属重度贫血。\n\n4. 白细胞计数（WBC）：4-10*（10的9次方）个/升\n白细胞计数大于10*（10的9次方）个/升称白细胞增多，小于4*（10的9次方）个/升称白细胞减少。一般地说，急性细菌感染或炎症时，白细胞可升高；病毒感染时，白细胞会降低。感冒、发热可由病毒感染引起，也可由细菌感染引起，为明确病因，指导临床用药，医生通常会让你去查一个血常规。\n\n5. 血小板计数（PLT）：100-300*（10的9次方）个/升\n血小板有维护血管壁完整性的功能。当血小板数减少到50*（10的9次方）个/升以下时，特别是低至30*（10的9次方）个/升时，就有可能导致出血，皮肤上可出现瘀点瘀斑。血小板不低皮肤上也常出现"乌青块"者不必过分紧张，因为除了血小板因素外，血管壁因素，凝血因素，以及一些生理性因素都会导致"乌青块"的发生，可去血液科就诊，明确原因。\n\n6.尿量：1000~2000毫升/24小时\n24小时尿量>2500毫升为多尿生理性多尿。见于饮水过多或应用利尿药后。病理性多尿见于糖尿病尿崩症肾小管疾病等。\n24小时尿量<400毫升为少尿，多见于饮水过少脱水肾功能不全等。\n24小时尿量<100毫升为无尿，多见于肾功能衰竭休克等严重疾病。\n提醒：如果您感觉自己最近尿量明显增多，特别容易口渴，应去医院检查，排除自己是否有糖尿病或肾小管疾病，若发现自己最近饮水不少，但尿量偏少，身上还有点肿，更应及时检查，排除肾脏疾患。\n\n7.夜尿量：500毫升\n夜尿指晚8时至次日晨8时的总尿量，一般为500毫升，排尿2~3次。若夜尿量超过白天尿量，且排尿次数明显增多，称为夜尿增多。生理性夜尿增多与睡前饮水过多有关；病理性夜尿增多常为肾脏浓缩功能受损的表现，是肾功能减退的早期信号。',
          publishTime: '2024-03-27',
          isPaid: true,
          price: 12.9
        },
        {
          id: 1011,
          title: '医学小常识（二）：健康指标与体重管理',
          category: '就医相关',
          content: '11.体重指数（BMI）=体重（千克）/身高（米）的平方：18.5~23.9属正常\n体重指数<18.5为体重过低，体重指数24.0~27.9为超重，体重指数28.0为肥胖。\n提醒：如果你的体重指数超过24,说明你已经偏胖，需要减肥了。\n记住：肥胖是百病之源，如果听之任之，糖尿病高血压冠心病都会找上你。\n\n12.最佳减肥速度：每月减重1~2公斤\n提醒：体重超标的人应在医生指导下逐步减轻体重，减肥过快过猛会导致体重反弹、厌食症、贫血、营养不良、月经不调、脱发、记忆力减退、骨质疏松等不良反应。\n\n13.腰围：男性90厘米，女性80厘米\n大于则为腹型肥胖腰围是判断腹部脂肪蓄积，即腹型肥胖（也称为苹果型肥胖）的指标腹型肥胖。目前被认为是冠心病，代谢综合征的重要危险因素。\n提醒：如果你的体重指数尚未达到肥胖程度，但腰围已超标，说明你属于腹型肥胖。腹型肥胖的人比全身都胖的人更危险，更容易受冠心病糖尿病的青睐，当心！\n\n14.肥胖信号：一个月增重1.5公斤\n提醒：在体重刚开始往上长的时候就及时发现，并采取减肥措施，往往能收到显着效果。出现下列情况，常提示有体重增加趋势：稍稍运动就喘不过气来，有疲倦无力感，动不动就汗流浃背，出现下背髋部及膝关节疼痛。\n\n15.血压正常值：收缩压<140毫米汞柱，舒张压<90毫米汞柱\n在安静时测量大于140毫米汞柱和（或）舒张压90毫米汞柱，可诊断为高血压。\n收缩压大于140毫米汞柱，但舒张压<90毫米汞柱，称为单纯收缩期高血压。\n提醒：高血压是心脑血管疾病的重要危险因素，高血压患者应在医生指导下应用降压药物，把血压控制在正常范围。有糖尿病肾病者，最好将血压控制在130/80毫米汞柱以下。\n\n16.糖化血红蛋白正常值6.5%\n糖化血红蛋白是红细胞内的血红蛋白与葡萄糖结合的产物，能反映采血前3个月的平均血糖水平，是目前反映血糖控制好坏最有效、最可靠的指标。\n糖尿病患者应将糖化血红蛋白7.0%作为治疗达标的标准之一，老年人可略放宽标准（7.0%~7.5%），中青年人应将糖化血红蛋白控制在6.5%或更低。\n提醒：糖化血红蛋白每下降1%,糖尿病相关并发症可减少20%! 因此，即使是无法达到上述标准的糖尿病患者，也应尽可能将糖化血红蛋白降至接近正常。\n\n17.骨密度最高的时期：30~40岁\n每个人一生中骨密度最高（骨峰值）的时期一般出现在30~40岁，受出生后营养发育和遗传等因素的影响，骨峰值有高有低。男性一般从40岁开始，女性一般从35岁开始，骨峰值开始下降。女性在绝经后5年内，男性在70岁以后，骨量丢失最快。\n提醒：骨峰值高的人，其骨内钙含量高，年老以后发生骨质疏松的程度较轻，时间较晚。因此，40岁之前的人应把握机会，保证每天足够的营养和钙的摄入，并积极参加体育锻炼，努力提高自己的骨峰值。\n\n18.每人每日用油25克为宜\n提醒：食用油是人体必需脂肪酸和维生素E的重要来源，但过量摄入会增加肥胖、高血压、冠心病等慢性病的风险。建议选择植物油，如橄榄油、菜籽油等，并控制每日用量。',
          publishTime: '2024-03-28',
          isPaid: true,
          price: 12.9
        },
        {
          id: 1012,
          title: '医学小常识（三）：日常健康指标与检查',
          category: '就医相关',
          content: '21.健康成人每日摄入钙600~800毫克\n中国营养学会推荐的钙供给量：成人600~800毫克/天，孕妇1200毫克/天，乳母2000毫克/天。\n提醒：乳及乳制品含钙丰富，吸收率高。水产品中，虾皮、海带、豆制品含钙较多。为促进钙的吸收，应适当补充维生素D并多晒太阳。\n\n22.每天饮水1500毫升以上\n提醒：饮水量包括每天摄入的茶水、汤水、果等食物的总含水量。饮水方式很有讲究，口不渴也要饮水，不要一次大量饮水，应饮白开水或清茶，不要用含糖饮料代替水等。\n\n23.中风（卒中）康复最佳开始时机：脑梗死后3天，脑出血后5~7天\n提醒：到目前为止，国内外还没有一种药物对偏瘫具有决定性的康复作用，唯有康复训练才是改善卒中病人功能障碍的有效方法。对卒中偏瘫病人而言，康复训练的效果远胜于用药，康复训练进行得越早越科学越完善，康复的机会就越大。\n\n24.丙氨酰转氨酶（GPT或ALT）正常值<40单位/升\n提醒：谷丙转氨酶升高多提示存在肝脏损害，如急慢性病毒性肝炎、酒精性肝炎、药物性肝炎、肝硬化等，应及时去医院就诊。\n\n25.甲胎蛋白（AFP）<25微克/升（也可参照化验单上的正常参考值）\n甲胎蛋白是在胎儿早期由肝脏合成的一种糖蛋白，出生后，AFP的合成很快受到抑制。当肝细胞发生恶变时，血中AFP含量明显增高。\n提醒：AFP升高，特别是略高于正常值时，并不一定表示患了恶性肿瘤，应动态观察，切莫惊慌失措。\n\n26.18~45岁近视度数<1200度：可做准分子激光近视眼手术\n提醒：年龄在18岁以下；近视度数不稳定，近年仍有逐年加深趋势；近视度数> 1200度；眼部有活动性病变（如炎症青光眼干眼症等）；角膜中央厚度<450微米；有其他严重眼病（如圆锥角膜等）；有自身免疫性疾病、瘢痕体质及严重糖尿病者等，都不能做准分子激光近视眼手术。\n\n27.40岁以上，每年查1次B超\n超声检查具有无创无辐射便捷及准确等优点，不仅可发现结石囊肿脂肪肝等常见疾病，还能早期发现某些肿瘤。\n提醒：受超声波物理性质所限，超声检查较适合实体器官，如肝脾肾等，一般不适合含气器官（比如胃肠）和骨骼系统。\n\n28.40岁以上女性，每年查1次钼靶摄影\n近年来，乳腺癌的发病率呈逐年上升趋势。乳腺钼靶摄影对乳腺疾病，特别是对早期乳腺癌具有较高的诊断价值，临床上将其作为除体检之外首选的影像学诊断方法。如有乳腺癌家族史等高危因素，应从35岁开始，每年接受一次乳腺钼靶摄影检查。40岁以后，根据医生意见适当增加检查次数。\n提醒：35岁以下的年轻女性乳腺组织致密，乳腺钼靶摄影不易发现病灶，建议将超声检查作为乳腺癌早期诊断的手段。',
          publishTime: '2024-03-29',
          isPaid: true,
          price: 12.9
        },
        {
          id: 1013,
          title: '老年人健康科普（上）',
          category: '老年人健康',
          content: '老年人的健康要注意些什么呢？\n一起来看看～\n\n1 积极认识老龄化和衰老\n老年人要不断强化自我保健意识，学习自我监护知识，掌握自我管理技能，早期发现和规范治疗疾病，对于中晚期疾病以维持功能为主。\n\n2 合理膳食，均衡营养\n老年人饮食要定时、定量，每日食物品种应包含粮谷类、杂豆类及薯类（粗细搭配），动物性食物，蔬菜、水果，奶类及奶制品，以及坚果类等，控制烹调油和食盐摄入量。建议老年人三餐两点，一日三餐能量分配为早餐约30%，午餐约40%，晚餐约30%，上下午各加一次零食或水果。\n\n3 适度运动，循序渐进\n老年人最好根据自身情况和爱好选择轻中度运动项目，如快走、慢跑、游泳、舞蹈、太极拳等。上午10～11点和下午3～5点为最佳运动时间，每次运动时间30～60分钟为宜。\n\n4 及早戒烟，限量饮酒\n戒烟越早越好。如饮酒，应当限量，避免饮用45度以上烈性酒，切忌酗酒。\n\n5 保持良好睡眠\n每天最好午休1小时左右。如果长期入睡困难或有严重的打鼾并呼吸暂停者，应当及时就医。如使用安眠药，请遵医嘱。\n\n6 定期自我监测血压\n测前应当休息5分钟，避免情绪激动、劳累、吸烟、憋尿。每次测量两遍，间隔1分钟，取两次的平均值。高血压患者每天至少自测血压3次（早、中、晚各1次）。警惕血压晨峰现象，防止心肌梗死和脑卒中；同时应当避免血压过低，特别是由于用药不当所致的低血压。',
          publishTime: '2024-03-30',
          isPaid: true,
          price: 12.9
        },
        {
          id: 1014,
          title: "老年人健康科普（下）",
          category: "老年人健康",
          content: "老年人的健康要注意些什么呢？\n一起来看看～\n\n11 重视口腔保健\n坚持饭后漱口、早晚刷牙，合理使用牙线或牙签；每隔半年进行1次口腔检查，及时修补龋齿孔洞；及时镶补缺失牙齿，尽早恢复咀嚼功能。\n\n12 预防跌倒\n老年人90%以上的骨折由跌倒引起。平时应当保持适度运动，佩戴适当的眼镜以改善视力，避免单独外出和拥挤环境，室内规则摆放物品，增加照明，保持地面干燥及平整。\n\n13 预防骨关节疾病和预防骨质疏松症\n注意膝关节保暖，避免过量体育锻炼，尽量少下楼梯，控制体重以减轻下肢关节压力。增加日晒时间。提倡富含钙、低盐和适量蛋白质的均衡饮食，通过步行或跑步等适度运动提高骨强度。\n\n14 预防压力性尿失禁\n注意改变使腹压增高的行为方式和生活习惯，如长期站立、蹲位、负重、长期慢性咳嗽、便秘等。\n\n15 保持良好心态，学会自我疏导\n一旦发觉老年人出现失眠、头痛、眼花、耳鸣等症状，并且心情压抑、郁闷、坐卧不安，提不起精神，为一点儿小事提心吊胆、紧张恐惧，对日常活动缺乏兴趣，常常自卑、自责、内疚，处处表现被动和过分依赖，感到生活没有意义等或心情烦躁、疲乏无力、胸闷、睡眠障碍、体重下降、头晕头痛等抑郁症早期症状，要及时就诊，请专科医生进行必要的心理辅导和药物治疗。\n\n16 预防阿尔茨海默病的发生发展\n阿尔茨海默病多数起病于65岁以后，主要表现为持续进行性的记忆、语言、视空间障碍及人格改变等。老年人一旦出现记忆力明显下降、近事遗忘突出等早期症状，要及早就诊，预防或延缓阿尔茨海默病的发生发展。\n\n17 合理用药\n用药需严格遵守医嘱，掌握适应证、禁忌证，避免重复用药、多重用药。不滥用抗生素、镇静睡眠药、麻醉药、消炎止痛药、抗心律失常药、强心药等。不轻易采用“秘方”、“偏方”、“验方”、“新药”、“洋药”等。用药期间出现不良反应可暂时停药，及时就诊。",
          publishTime: "2025-06-12",
          isPaid: true,
          price: 8.9
        },
        {
          id: 1015,
          title: "职业病知识科普（上）",
          category: "职业病知识科普",
          content: "一、什么是职业病？职业病是指企业、事业单位和个体经济组织等用人单位的劳动者，在职业活动中因接触有害因素而引起的疾病，必须符合四点认定条件。\n\n二、我国法定职业病包括10类132种，涵盖尘肺病、皮肤病、化学中毒、放射性疾病、职业性肿瘤等。\n\n三、用人单位是职业病防治的责任主体，应为劳动者提供符合卫生标准的工作环境。\n\n四、矿山开采、机械制造、建材等行业是尘肺病高发领域。\n\n五、防尘防毒措施包括密闭设备、通风除尘、佩戴防护用品、定期检测与健康检查等。",
          publishTime: "2025-06-12",
          isPaid: true,
          price: 8.9
        },
        {
          id: 1016,
          title: "职业病知识科普（下）",
          category: "职业病知识科普",
          content: "六、如何预防铅中毒？介绍铅中毒的预防措施。\n\n七、为什么接触职业危害的劳动者要进行职业健康检查？解释职业健康检查的目的和分类。\n\n八、哪些人需要上岗前职业健康检查？列举需要进行上岗前职业健康检查的人员类型。\n\n九、职业病病人都享有哪些待遇？详细说明职业病病人应享有的权益和保障。\n\n十、职业病诊断需要哪些资料？列出职业病诊断所需的各种资料。",
          publishTime: "2025-06-12",
          isPaid: true,
          price: 8.9
        }
      ]
    };
  },
  created() {
    // 检查登录状态
    this.checkLoginStatus();
    // 监听登录状态变化事件
    eventBus.$on('login-status-changed', this.checkLoginStatus);
  },
  beforeDestroy() {
    // 移除事件监听
    eventBus.$off('login-status-changed', this.checkLoginStatus);
  },
  computed: {
    filteredList() {
      return this.activeCategory
        ? this.infoList.filter(item => item.category === this.activeCategory)
        : this.infoList;
    }
  },
  methods: {
    checkLoginStatus() {
      // 更新登录状态检查逻辑
      const currentUser = localStorage.getItem('currentUser');
      const isAdmin = localStorage.getItem('isAdmin') === 'true';
      this.isLoggedIn = Boolean(currentUser) || isAdmin;
    },
    getCategoryClass(category) {
      const classMap = {
        '就医相关': 'medical',
        '药品相关': 'medicine',
        '中医相关': 'tcm',
        '饮食相关': 'diet',
        '老年人健康': 'elderly',
        '职业病知识科普': 'Occupational'
      };
      return classMap[category] || '';
    },
    truncateText(text, maxLength) {
      // 移除换行符和多余空格
      const cleanText = text.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
      return cleanText.length > maxLength ? cleanText.slice(0, maxLength) + '...' : cleanText;
    },
    formatDate(dateStr) {
      return dateStr.replace(/-/g, '/');
    },
    handleCardClick(item) {
      // 如果是付费内容且未登录，不允许查看
      if (item.isPaid && !this.isLoggedIn) {
        this.handlePaidContent();
        return;
      }
      // 跳转到详情页
      this.$router.push(`/infoDetailsView/${item.id}`);
    },
    handlePaidContent() {
      if (!this.isLoggedIn) {
        this.$notification['info']({
          message: '提示',
          description: '该内容为付费阅读，请先登录',
          duration: 2,
          onClose: () => {
            this.$emit('openLogin');
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.info-list {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.filter-section {
  margin-bottom: 30px;
}

.category-select {
  padding: 10px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  width: 200px;
}

.info-container {
  display: grid;
  gap: 20px;
}

.info-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  transition: transform 0.2s;
  cursor: pointer;
}

.info-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.category-tag {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 15px;
}

.category-tag.medical {
  background: #fef6e6;
  color: #d48806;
}

.category-tag.medicine {
  background: #e6fffb;
  color: #08979c;
}

.category-tag.tcm {
  background: #f0f5ff;
  color: #1d39c4;
}

.category-tag.diet {
  background: #f6ffed;
  color: #52c41a;
}

.category-tag.elderly {
  background: #fff7e6;
  color: #d48806;
}

.category-tag.Occupational {
  background: #fff7e6;
  color: #f4a708;
}

.info-title {
  font-size: 18px;
  color: #333;
  margin: 0;
}

.info-summary {
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.publish-time {
  color: #999;
  font-size: 14px;
}

.price-tag {
  color: #f5222d;
  font-weight: bold;
  font-size: 16px;
}

.read-more-btn {
  background: #1890ff;
  color: white;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.read-more-btn:hover {
  background: #40a9ff;
}

.read-all-btn {
  background: #52c41a;
}

.read-all-btn:hover {
  background: #73d13d;
}

.card-footer {
  text-align: right;
}
</style>